var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.currentPanel,{tag:"component",on:{"close":_vm.close},model:{value:(_vm.showPanel),callback:function ($$v) {_vm.showPanel=$$v},expression:"showPanel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }